// import React, { useState, useEffect } from 'react';
// // Cambié el nombre del archivo para hacerlo más específico

// function BD({ apiCentral }) {
//   const [data, setData] = useState([]);

//   useEffect(() => {
//     fetch(`${apiCentral}/api/get/restaurant`)
//       .then(res => res.json())
//       .then(date => setData(date));
//   }, [apiCentral]);

//   const functionActualizatePay = async (idRestaurant, e) => {
//     e.preventDefault(); // Evitar recarga de página
//     const date = new Date().toString(); // Obtener la fecha actual como cadena
  
//     try {
//       // Enviar los datos a la API
//       const response = await fetch(`${apiCentral}/actualizatePay`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           id: idRestaurant,
//           date: date
//         }), // Convertir datos del formulario a JSON
//       });
  
//       if (!response.ok) {
//         throw new Error('Hubo un error en la solicitud');
//       }
  
//       const data = await response.json();
//       console.log('Respuesta de la API:', data);
//       alert('Datos enviados con éxito');
//     } catch (error) {
//       console.error('Error:', error);
//       alert('Hubo un error al enviar los datos');
//     }
//   };
  

//   return (
//     <div className="dashboard-restaurantes-container">
//       <h2 className="dashboard-restaurantes-title">Lista de Restaurantes Activos</h2>
//       <table className="restaurantes-data-table">
//         <thead>
//           <tr>
//             <th style={{ textAlign: 'center' }}>Nombre Restaurante</th>
//             <th style={{ textAlign: 'center' }}>Plan</th>
//             <th style={{ textAlign: 'center' }}>Número Servicio</th>
//             <th style={{ textAlign: 'center' }}>Fecha Pago</th>
//             <th style={{ textAlign: 'center' }}>Nombre Responsable</th>
//             <th style={{ textAlign: 'center' }}>Tamaño Restaurante</th>
//             <th style={{ textAlign: 'center' }}>Número Mesas</th>
//             <th style={{ textAlign: 'center' }}>Dominio</th>
//             <th style={{ textAlign: 'center' }}>Telefono</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((restaurant, index) => (
//             <tr key={index}>
//               <td style={{ textAlign: 'center' }}>{restaurant.nombreRestaurante}</td>
//               <td style={{ textAlign: 'center' }}>{restaurant.plan}</td>
//               <td style={{ textAlign: 'center' }}>{restaurant.numeroServicio}</td>
//               <td style={{ textAlign: 'center' }}>{restaurant.fechaPago}</td>
//               <td style={{ textAlign: 'center' }}>{restaurant.nombreResponsable}</td>
//               <td style={{ textAlign: 'center' }}>{restaurant.tamanoRestaurante}</td>
//               <td style={{ textAlign: 'center' }}>{restaurant.numeroMesas}</td>
//               <td style={{ textAlign: 'center' }}>{restaurant.dominio}</td>
//               <td style={{ textAlign: 'center' }}>{restaurant.telefono}</td>
//               <button 
//                   style={{ textAlign: 'center' }} 
//                   onClick={(e) => functionActualizatePay(restaurant.id, e)} // Correcta forma de pasar los parámetros
//                 >
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// }

// export default BD;



import React, { useState, useEffect } from 'react';

function BD({ apiCentral }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch(`${apiCentral}/api/get/restaurant`)
      .then(res => res.json())
      .then(date => setData(date));
  }, [apiCentral]);

  const functionActualizatePay = async (idRestaurant, e) => {
    e.preventDefault(); // Evitar recarga de página
    const date = new Date().toLocaleDateString('en-CA'); // Obtener la fecha actual en formato ISO
    
    try {
      // Enviar los datos a la API usando PUT
      const response = await fetch(`${apiCentral}/actualizatePay`, {
        method: 'PUT', // Cambiar a PUT
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: idRestaurant,
          date: date
        }), // Convertir datos del formulario a JSON
      });
  
      if (!response.ok) {
        throw new Error('Hubo un error en la solicitud');
      }
  
      const data = await response.json();
      console.log('Respuesta de la API:', data);
      alert('Datos enviados con éxito');
    } catch (error) {
      console.error('Error:', error);
      alert('Hubo un error al enviar los datos');
    }
  };
  
  return (
    <div className="dashboard-restaurantes-container">
      <h2 className="dashboard-restaurantes-title">Lista de Restaurantes Activos</h2>
      <table className="restaurantes-data-table">
        <thead>
          <tr>
            <th style={{ textAlign: 'center' }}>Nombre Restaurante</th>
            <th style={{ textAlign: 'center' }}>Plan</th>
            <th style={{ textAlign: 'center' }}>Número Servicio</th>
            <th style={{ textAlign: 'center' }}>Fecha Pago</th>
            <th style={{ textAlign: 'center' }}>Nombre Responsable</th>
            <th style={{ textAlign: 'center' }}>Tamaño Restaurante</th>
            <th style={{ textAlign: 'center' }}>Número Mesas</th>
            <th style={{ textAlign: 'center' }}>Dominio</th>
            <th style={{ textAlign: 'center' }}>Telefono</th>
          </tr>
        </thead>
        <tbody>
          {data && data.map((restaurant, index) => (
            <tr key={index}>
              <td style={{ textAlign: 'center' }}>{restaurant.nombreRestaurante}</td>
              <td style={{ textAlign: 'center' }}>{restaurant.plan}</td>
              <td style={{ textAlign: 'center' }}>{restaurant.numeroServicio}</td>
              <td style={{ textAlign: 'center' }}>{restaurant.fechaPago}</td>
              <td style={{ textAlign: 'center' }}>{restaurant.nombreResponsable}</td>
              <td style={{ textAlign: 'center' }}>{restaurant.tamanoRestaurante}</td>
              <td style={{ textAlign: 'center' }}>{restaurant.numeroMesas}</td>
              <td style={{ textAlign: 'center' }}>{restaurant.dominio}</td>
              <td style={{ textAlign: 'center' }}>{restaurant.telefono}</td>
              <td style={{ textAlign: 'center' }}>
                <button 
                  style={{ textAlign: 'center' }} 
                  onClick={(e) => functionActualizatePay(restaurant.id, e)} // Correcta forma de pasar los parámetros
                >
                  Actualizar pago
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default BD;
